var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Type } from '@sinclair/typebox';
import { completePurchaseResponseSchema } from "./cart/completePurchase.mjs";
import { postWithRetries } from "./http.mjs";
import { getAdditionalHeaders } from "./actions.mjs";
import { logger } from "./log.mjs";
export const sendCompletePurchase = (state, paymentProvider, providerData, recaptchaToken) => __awaiter(void 0, void 0, void 0, function* () {
    const request = {
        providerData,
        paymentProvider,
        recaptchaToken,
        trackingCookies: state.trackingCookies,
    };
    try {
        const response = yield postWithRetries(`/carts/${state.id}/${state.version}/complete-purchase`, state.checkoutApiBaseUrl, request, completePurchaseResponseSchema, state.token, getAdditionalHeaders(state));
        return response;
    }
    catch (err) {
        logger.error({ err }, 'Failed to execute complete purchase');
        return { $type: 'unexpectedError' };
    }
});
export const completePurchaseErrorCodeSchema = Type.Union([
    Type.Literal('payment_authentication_failed'),
    Type.Literal('payment_invalid'),
    Type.Literal('payment_declined'),
    Type.Literal('invalid_card_details'),
    Type.Literal('insufficient_funds'),
    Type.Literal('processing_error'),
    Type.Literal('invalid_request'),
    Type.Literal('account_issue'),
    Type.Literal('unsupported'),
    Type.Literal('rate_limited'),
    Type.Literal('unknown'),
]);
//# sourceMappingURL=completePurchase.js.map